import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminOrders from "@/pages/admin/AdminOrders";

export const Route = createFileRoute("/admin/orders/")({
  head: () => pageHead("Admin \u2014 Orders \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminOrders,
});
